"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStore = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var utils_1 = require("../utils");
var ONE_YEAR = 365;
/**
 * Representation of browser cookies
 */
var CookieStore = /** @class */ (function () {
    function CookieStore(options) {
        if (options === void 0) { options = CookieStore.defaults; }
        this.options = __assign(__assign({}, CookieStore.defaults), options);
    }
    /**
     * Try setting a browser cookie value to test if cookies are available
     */
    CookieStore.available = function () {
        if ((0, utils_1.isServer)()) {
            return false;
        }
        var cookieEnabled = window.navigator.cookieEnabled;
        if (!cookieEnabled) {
            js_cookie_1.default.set('s10:cookie-test', 'test');
            cookieEnabled = document.cookie.includes('s10:cookies');
            js_cookie_1.default.remove('s10:cookie-test');
        }
        return cookieEnabled;
    };
    Object.defineProperty(CookieStore, "defaults", {
        /**
         * CookieStore default Option values
         */
        get: function () {
            if ((0, utils_1.isServer)()) {
                return {
                    maxage: ONE_YEAR,
                    domain: undefined,
                    path: '/',
                    sameSite: 'Strict',
                    secure: true,
                };
            }
            return {
                maxage: ONE_YEAR,
                domain: window.location.href,
                path: '/',
                sameSite: 'Strict',
                secure: true,
            };
        },
        enumerable: false,
        configurable: true
    });
    CookieStore.prototype.opts = function () {
        return {
            sameSite: this.options.sameSite,
            expires: this.options.maxage,
            domain: this.options.domain,
            path: this.options.path,
            secure: this.options.secure,
        };
    };
    /**
     * Get from browser cookie
     * @param key Key to get
     * @returns
     */
    CookieStore.prototype.get = function (key) {
        if (!CookieStore.available()) {
            return undefined;
        }
        try {
            var value = js_cookie_1.default.get(key);
            if (value === null || value === undefined) {
                return value;
            }
            try {
                return JSON.parse(value);
            }
            catch (e) {
                return value;
            }
        }
        catch (e) {
            return undefined;
        }
    };
    /**
     * Set a browser cookie
     * @param key Key to set
     * @param value Value to store
     * @returns
     */
    CookieStore.prototype.set = function (key, value) {
        if (!CookieStore.available()) {
            return undefined;
        }
        if (typeof value === 'string') {
            js_cookie_1.default.set(key, value, this.opts());
        }
        else if (value === null) {
            js_cookie_1.default.remove(key, this.opts());
        }
        else {
            js_cookie_1.default.set(key, JSON.stringify(value), this.opts());
        }
        return value;
    };
    /**
     * Remove item from browser cookies
     * @param key Key to remove
     * @returns
     */
    CookieStore.prototype.remove = function (key) {
        return js_cookie_1.default.remove(key, this.opts());
    };
    return CookieStore;
}());
exports.CookieStore = CookieStore;
//# sourceMappingURL=cookie.store.js.map